'use strict';

var quickBuyBarHeight = $('.quickbuy--container').outerHeight();

/* Javascript to load on page load*/
$(document).ready(function () {
    $(document).on('click', '.ratings .TTteaser__read-qa', function () {
        const scrollSelectors = ['.turnto-qna-heading', '#tt-instant-answers-widget', '.turnto-qa-navigation'];
        for (let selector of scrollSelectors) {
            var scrollElement = $(selector);
            if (scrollElement.length) {
                window.scrollTo(0, scrollElement.offset().top - quickBuyBarHeight);
                break;
            }
        }
    });

    $(document).on('click', '.ratings .TTteaser__rating, .ratings .TTteaser__read-reviews', function () {
        window.scrollTo(0, $('.turnto-review-navigation').offset().top - quickBuyBarHeight);
    });
});